/** Synthetic auditFindingId when CAPA links to a closed audit (no action row). */
export const AUDIT_LEVEL_FINDING_PREFIX = '__audit__:';

export function auditLevelFindingId(auditId) {
  return `${AUDIT_LEVEL_FINDING_PREFIX}${auditId}`;
}

export function isAuditLevelFindingId(findingId) {
  return (
    typeof findingId === 'string' && findingId.startsWith(AUDIT_LEVEL_FINDING_PREFIX)
  );
}

/**
 * @returns {{ auditId: string|null, auditFindingId: string|null }}
 */
export function parseAuditCapaSource(auditFindingId) {
  if (!auditFindingId || !isAuditLevelFindingId(auditFindingId)) {
    return { auditId: null, auditFindingId: auditFindingId || null };
  }
  return {
    auditId: auditFindingId.slice(AUDIT_LEVEL_FINDING_PREFIX.length),
    auditFindingId: null
  };
}
